export default __webpack_public_path__ + "static/media/hall_of_fame_header_three.e6d6af90.png";